/**
 * AuthProvider - React context that provides auth state to the component tree.
 */

import type { ReactNode } from 'react'
import { AuthContext } from './auth-context.js'
import { useAuth } from './useAuth.js'

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const auth = useAuth()
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}
